<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14 8L10 12L14 16" stroke="#2A3243" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>